import { createAction, props } from '@ngrx/store';

export const setTableColumnState = createAction(
    '[Column State] Set Table Column State',
    props<{ tableId: string; columns: string[] }>(), // Update type to string[]
);

export const resetTableColumnState = createAction('[Column State] Reset Table Column State', props<{ tableId: string }>());

export const resetAllTables = createAction('[Column State] Reset All Tables');
